import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'src/app/shared/services/api.service';

export interface DocumentUploadPromptData {
  isFirstLogin: boolean;
  pendingDocuments: { document_type: string; document_name: string }[];
  staffName?: string;
}

@Component({
  selector: 'app-document-upload-prompt',
  templateUrl: './document-upload-prompt.component.html',
  styleUrls: ['./document-upload-prompt.component.css']
})
export class DocumentUploadPromptComponent implements OnInit {
  isFirstLogin: boolean = false;
  pendingDocuments: { document_type: string; document_name: string }[] = [];
  staffName: string = '';
  dontShowAgain: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<DocumentUploadPromptComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DocumentUploadPromptData,
    private router: Router,
    private apiService: ApiService
  ) {
    this.isFirstLogin = data.isFirstLogin;
    this.pendingDocuments = data.pendingDocuments || [];
    this.staffName = data.staffName || '';
  }

  ngOnInit(): void {}

  goToDocuments(): void {
    // Mark first login as complete if it was first login
    if (this.isFirstLogin) {
      this.apiService.completeFirstLogin().subscribe({
        error: (err) => console.error('Error completing first login:', err)
      });
    }
    this.dialogRef.close('upload');
    this.router.navigate(['/home/profile/identity-documents']);
  }

  remindLater(): void {
    if (this.dontShowAgain) {
      localStorage.setItem('skipDocumentPrompt', 'true');
      localStorage.setItem('skipDocumentPromptDate', new Date().toISOString());
    }
    this.dialogRef.close('later');
  }

  skipForNow(): void {
    // Mark first login as complete
    if (this.isFirstLogin) {
      this.apiService.completeFirstLogin().subscribe({
        error: (err) => console.error('Error completing first login:', err)
      });
    }
    this.dialogRef.close('skip');
  }
}
